import {Component, OnInit, Input} from '@angular/core';
import * as _ from 'lodash';
import {ToasterService} from 'angular2-toaster/src/toaster.service';
import {TrailerService} from './trailer.service';

@Component({
    selector: 'app-trailer',
    templateUrl: 'trailers.component.html',
    styleUrls: ['trailer.component.scss']
})
export class TrailerComponent implements OnInit {

    // tslint:disable-next-line:comment-format
    private results = [];
    private primaryResults = [];
    private otherResults = [];
    private addTrailer = '';
    dataLoaded = false;

    @Input() selectedTitle: any;
    selectedParrotId: string;
    selectedContentType: string;

    private ADD_TRAILER_OBJECT = {

        'content_type': '',
        'source': 'helpdesk',
        'type': 'youtube',
        'url': '',
        'is_primary': false
    };

    private MAKE_PRIMARY_TRAILER_OBJECT = {

        'content_type': '',
        'url': '',
        'is_primary': true
    };

    constructor(private toasterService: ToasterService,
                private trailerService: TrailerService,
    ) {
    }

    ngOnInit() {
        this.selectedParrotId = this.selectedTitle.parrot_id;
        this.selectedContentType = this.selectedTitle.content_type;
        this.getTrailers(this.selectedParrotId);
    }

    getTrailers(parrotID: any) {
        this.trailerService
            .getTrailers(parrotID)
            .then(res => {
                this.results = [];
                if (res.results.length > 0) {
                    this.results = this.results.concat(res.results.map(item => this.trailerService.mapIndividualTrailerItem(item)));
                }
                for (const result of this.results) {
                    if (result.is_primary) {
                        this.primaryResults.push(result);
                    } else {
                        this.otherResults.push(result);
                    }
                }
                this.dataLoaded = true;
            })
            .catch(error => {
                console.log(error);
            });
    }

    onOriginalKeyUp(value, type) {
        switch (type) {
            case 'addVideo':
                this.addTrailer = value;
                break;
        }
    }

    createAddTrailerPayload() {
        let contentType = this.selectedContentType;
        if (contentType === 'tv') {
            contentType = 'show';
        }

        const requestQuery = _.cloneDeep(this.ADD_TRAILER_OBJECT);
        requestQuery.content_type = contentType;
        requestQuery.url = this.addTrailer;
        return JSON.stringify(requestQuery);
    }

    createMakePrimaryTrailerPayload(url) {

        let contentType = this.selectedContentType;
        if (contentType === 'tv') {
            contentType = 'show';
        }

        const requestQuery = _.cloneDeep(this.MAKE_PRIMARY_TRAILER_OBJECT);
        requestQuery.content_type = contentType;
        requestQuery.url = url;
        return JSON.stringify(requestQuery);
    }

    handleSubmit() {

        this.results = [];
        this.primaryResults = [];
        this.otherResults = [];
        this.dataLoaded = false;
        const payload = this.createAddTrailerPayload();
        this.trailerService.addTrailer(
            payload, this.selectedParrotId
        ).then((res) => {
            this.getTrailers(this.selectedParrotId);
            this.addTrailer = '';
        }).catch((err) => {
            console.error('Failed to add the trailer' + err.toString());
            this.toasterService.pop('error', 'Failed to add trailer');
            this.getTrailers(this.selectedParrotId);
        });
    }

    handleDeleteTrailer(url: string) {

        this.results = [];
        this.primaryResults = [];
        this.otherResults = [];
        this.dataLoaded = false;
        this.trailerService.deleteTrailer(
            this.selectedParrotId, url
        ).then((res) => {
            this.getTrailers(this.selectedParrotId);
            this.addTrailer = '';
        }).catch((err) => {
            console.error('Failed to delete the trailer' + err.toString());
            this.toasterService.pop('error', 'Failed to delete trailer');
            this.getTrailers(this.selectedParrotId);
        });
    }

    handleMakePrimaryTrailer(url: string) {

        this.results = [];
        this.primaryResults = [];
        this.otherResults = [];
        this.dataLoaded = false;
        const payload = this.createMakePrimaryTrailerPayload(url);
        this.trailerService.makePrimaryTrailer(
            payload, this.selectedParrotId
        ).then((res) => {
            this.getTrailers(this.selectedParrotId);
            this.addTrailer = '';
        }).catch((err) => {
            console.error('Failed to Make the trailer primary' + err.toString());
            this.toasterService.pop('error', 'Failed to make the trailer primary');
            this.getTrailers(this.selectedParrotId);
        });
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    viewURL(value) {
        const newWindow = window.open(value);
    }
}




// WEBPACK FOOTER //
// ./src/app/catalogue/trailers/trailer.component.ts